import Api from './../api'

export default DataLayer => DataLayer.$extend('genres', {
    getAll() {
        return Api.genres.get()
    },
    getBySlug({ slug }) {
        return Api.genres.getBySlug({ slug })
    },
})
